import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAtmedEquipmentFeedBack,
} from '../../../store/actions';
import FeedBack from './Feedback';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  allEquipmentFeedback: vendorEquipmenReducer.allEquipmentFeedback,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAtmedEquipmentFeedBack,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(FeedBack);
